import { ApolloError } from '@apollo/client';

export const isErrorButNotApolloOne = (error: unknown): error is Error =>
  !(error instanceof ApolloError) && error instanceof Error;
